// extracted by mini-css-extract-plugin
module.exports = {"root":"SocialMediaControls_root__rPDrV","leftAlignedButton":"SocialMediaControls_leftAlignedButton__W_I07"};